import Vue from 'vue';
export const UPDATE_FILTERS = 'UPDATE_FILTERS';
export const CLEAR_FILTERS = 'CLEAR_FILTERS';
export const UPDATE_SELECTED_COLLECTION = 'UPDATE_SELECTED_COLLECTION';
export const UPDATE_SEARCH_TERM = 'UPDATE_SEARCH_TERM';
export const UPDATE_ACTIVE_IMAGE_INDEX = 'UPDATE_ACTIVE_IMAGE_INDEX';
export const UPDATE_SELECTED_GALLERY_PROJECT =
  'UPDATE_SELECTED_GALLERY_PROJECT';
export const CLOSE_GALLERY_PROJECT_MODAL = 'CLOSE_GALLERY_PROJECT_MODAL';
export const GALLERY_PROJECT_IMAGE_LOADED = 'GALLERY_PROJECT_IMAGE_LOADED';
export const UPDATE_CURRENT_PAGE = 'UPDATE_CURRENT_PAGE';
export const REFRESH_SEARCH = 'REFRESH_SEARCH';
export const TOGGLE_CATEGORIES = 'TOGGLE_CATEGORIES';
export const UPDATE_SELECTED_SAMPLE_TYPE = 'UPDATE_SELECTED_SAMPLE_TYPE';

export const eventBus = new Vue({
  methods: {
    updateSelectedFilters(data) {
      this.$emit(UPDATE_FILTERS, data);
    },
    clearAllFilters() {
      this.$emit(CLEAR_FILTERS, {});
    },
    updateSelectedCollection(data) {
      this.$emit(UPDATE_SELECTED_COLLECTION, data);
    },
    updateSearchTerm(data) {
      this.$emit(UPDATE_SEARCH_TERM, data);
    },
    updateActiveImageIndex(data) {
      this.$emit(UPDATE_ACTIVE_IMAGE_INDEX, data);
    },
    updateSelectedGalleryProject(data = {}) {
      this.$emit(UPDATE_SELECTED_GALLERY_PROJECT, data);
    },
    closeGalleryProjectModal() {
      this.$emit(CLOSE_GALLERY_PROJECT_MODAL);
    },
    galleryProjectImageLoaded(data) {
      this.$emit(GALLERY_PROJECT_IMAGE_LOADED, data);
    },
    updateCurrentPage(data) {
      this.$emit(UPDATE_CURRENT_PAGE, data);
    },
    refreshSearch() {
      this.$emit(REFRESH_SEARCH, {});
    },
    toggleCategories() {
      this.$emit(TOGGLE_CATEGORIES, {});
    },
    updateSelectedSampleType(data) {
      this.$emit(UPDATE_SELECTED_SAMPLE_TYPE, data);
    },
  },
});
